import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const specialPromosBlocksSelector = rootStateBranchSelector('specialPromosBlocks');
